import React from 'react';
import { Button, Textarea, mergeClasses, useId } from '@fluentui/react-components';
import {
  SendRegular,
} from '@fluentui/react-icons';

export const MAX_PROMPT_LENGTH = 200;

export const PromptEditorV2 = (props) => {
  const {
    i18n,
    prompt,
    setPrompt,
    disabledText,
    onKeyDownInTextArea,
    placeholder,
    textAreaRef,
  } = props;

  const textAreaId = useId('prompt-editor-textarea');

  return (
    <>
      <div className={mergeClasses('prompt-title', 'prompt-editor-label')}>{i18n.getString(_TL_('What background do you want to create?'))}</div>
      <div className={mergeClasses('prompt-editor', 'prompt-editor-new', 'prompt-editor-text-container')}>
        <Textarea
          ref={textAreaRef}
          value={prompt || ''}
          onChange={(e, data) => setPrompt(data.value)}
          onKeyDown={onKeyDownInTextArea}
          className={mergeClasses('prompt-textarea', disabledText && 'disabled-prompt-textarea')}
          aria-label={i18n.getString(_TL_('Prompt Editor'))}
          aria-describedby={textAreaId}
          placeholder={placeholder}
          disabled={disabledText}
        />
        <div id={textAreaId} style={{ display: 'none' }}>{i18n.getString(_TL_('{{prompt}}'), { prompt })}</div>
      </div>
    </>
  );
};

export const PromptEditor = (props) => {
  const {
    i18n,
    prompt,
    setPrompt,
    disabledText,
    disabledButton,
    onKeyDownInTextArea,
    onClickGenerateButton,
    placeholder,
  } = props;

  const textAreaId = useId('prompt-editor-textarea');

  return (
    <>
      <div className={mergeClasses('prompt-title', 'prompt-editor-label')}>{i18n.getString(_TL_('What background do you want to create?'))}</div>
      <div className={mergeClasses('prompt-editor', 'prompt-editor-text-container')}>
        <Textarea
          value={prompt || ''}
          onChange={(e, data) => setPrompt(data.value)}
          onKeyDown={onKeyDownInTextArea}
          className="prompt-textarea"
          aria-label={i18n.getString(_TL_('Prompt Editor'))}
          aria-describedby={textAreaId}
          placeholder={placeholder}
          disabled={disabledText}
        />
        <div id={textAreaId} style={{ display: 'none' }}>{i18n.getString(_TL_('{{prompt}}'), { prompt })}</div>
        <div className={mergeClasses('action-bar', 'prompt-editor-actions-container')}>
          <Button
            icon={<SendRegular />}
            appearance="transparent"
            onClick={onClickGenerateButton}
            disabled={disabledButton}
            className={mergeClasses('generate-button', disabledButton ? 'disabled' : 'enabled')}
            aria-label={i18n.getString(_TL_('Expand background'))}
          />
        </div>
      </div>
    </>
  );
};
